import gql from 'graphql-tag'
import client from '@stores/apollo'
import { BuildingTypeFragment } from '@api/fragments'
import { IBuildingTypeWithCompany } from '@api/types'
import handleFetchResult from '@utils/handleFetchResult'

interface IPayload {
  updateBuildingType: {
    buildingType: IBuildingTypeWithCompany
  }
}

const mutateHandler = handleFetchResult<IPayload, IBuildingTypeWithCompany>({
  handler: (data) => data.updateBuildingType.buildingType,
  name: 'Building Type',
})

export default function update(id: string, name: string) {
  return client.gql
    .mutate({ mutation, variables: { input: { id, displayName: name } } })
    .then(mutateHandler)
}

const mutation = gql`
  mutation updateBuildingType($input: UpdateBuildingTypeInput!) {
    updateBuildingType(input: $input) {
      buildingType {
        ...BuildingTypeFragment
        company {
          id
        }
      }
    }
  }
  ${BuildingTypeFragment}
`
